import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { reportPushOpened } from '../api/pushEvent'
import { useAuthStore } from '../stores/authStore'

/**
 * 푸시를 눌러서 들어왔으면 서버에 한 번 알린다.
 *
 * 앱은 알림을 누르면 목적지로 옮기기만 하고 서버에 알리지 않는다. 그래서
 * 푸시 주소에 from=<캠페인> 표식을 달아두고 웹이 대신 보고한다.
 *
 * 왜 화면마다가 아니라 여기인가
 * ------------------------------
 * 예전에는 이 보고가 홈 화면(MainHome)에만 있었다. 그래서 홈이 아닌 곳으로
 * 보내는 푸시는 열람이 아예 집계되지 않았다. 실제로 한 사용자에게 리스트
 * 화면으로 보내는 푸시를 보냈다가, 열었는지 끝내 알 수 없었다.
 * 목적지와 무관하게 세도록 모든 화면을 감싸는 곳으로 옮긴다.
 *
 * 같은 표식으로 여러 번 들어와도 한 번만 보낸다 — 새로고침·뒤로가기로 같은
 * 주소를 다시 열 수 있기 때문이다. (서버에도 유일 제약이 있어 이중 안전)
 */
export function usePushOpenReport(): void {
  const location = useLocation()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  useEffect(() => {
    if (!isAuthenticated) return

    const campaign = new URLSearchParams(location.search).get('from')
    if (!campaign) return

    const key = `push_opened:${campaign}`
    try {
      if (sessionStorage.getItem(key) === '1') return
      sessionStorage.setItem(key, '1')
    } catch {
      /* 저장소를 못 써도 보고는 한 번 시도한다 */
    }

    void reportPushOpened(campaign)
  }, [isAuthenticated, location.search])
}
